import services from "../json/services.json"
import "../css/Services.css"

const Services = () => {

    return (
        <main id="services">
            {services.map(service =>
                <section key={service.id} className={"acenter service-" + service.orientation}>
                    <div className="flex col service-description">
                        <h2 className="cspica">{service.title}</h2>
                        {service.description?.map((d, index) =>
                            <p key={index} className="tjustify ">{d.content}</p>
                        )}
                        <ul>
                            {service.list?.map((d, index) =>
                                <li key={index}>{d.content}</li>
                            )}
                        </ul>
                    </div>
                    <div className="pad-50 flex col acenter tv">
                        <img className="services-img" alt={service.title} src={"/images/" + service.image}></img>
                        <div className="tv-medium"></div>
                        <div className="tv-bottom"></div>
                    </div>
                </section>
            )}
        </main>
    )
}

export default Services